import sendOwsAttachmentRequest from './httpRequestHelpers/sendOwsAttachmentRequest';
import prependServiceBaseUrl from '../utils/prependServiceBaseUrl';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import CreateAttachmentResponse from 'owa-service/lib/contract/CreateAttachmentResponse';
import FileAttachment from 'owa-service/lib/contract/FileAttachment';
import createAttachmentJsonRequest from 'owa-service/lib/factory/createAttachmentJsonRequest';
import createAttachmentRequest from 'owa-service/lib/factory/createAttachmentRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { trace } from 'owa-trace';
import { ClientItemId } from 'owa-client-ids';

const CREATE_ATTACHMENT_URL = prependServiceBaseUrl('/service.svc/CreateAttachmentFromLocalFile');

export interface SliceInformation {
    sliceNumber: number;
    totalSlices: number;
}

export default async function createAttachmentFromLocalFile(
    parentItemId: ClientItemId,
    attachment: AttachmentType,
    cancellationId: string,
    backingObject: Blob,
    onProgressHandler?: (e: ProgressEvent) => void,
    sliceInformation?: SliceInformation
): Promise<CreateAttachmentResponse> {
    const requestBody = createAttachmentRequest({
        ParentItemId: parentItemId,
        Attachments: [attachment],
        RequireImageType: attachment.IsInline,
        IncludeContentIdInResponse: attachment.IsInline,
        ClientSupportsIrm: true,
        CancellationId: cancellationId,
    });

    if (sliceInformation) {
        // If slice information is present then add that information in the request
        requestBody.SliceNumber = sliceInformation.sliceNumber;
        requestBody.TotalSlices = sliceInformation.totalSlices;
    }

    const jsonRequest = createAttachmentJsonRequest({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    });

    const fileAttachment = attachment as FileAttachment;

    trace.info(
        `Attachment: createAttachment Id: ${parentItemId.Id}, ChangeKey: ${parentItemId.ChangeKey}`
    );

    const jsonResponse = await sendOwsAttachmentRequest(
        CREATE_ATTACHMENT_URL,
        jsonRequest,
        'CreateAttachmentFromLocalFile',
        parentItemId.mailboxInfo,
        fileAttachment && backingObject ? backingObject : null,
        onProgressHandler
    );

    return jsonResponse.Body;
}
